import * as React from "react";
import {AppState} from "../components/app/app-mobx";
import {MapViewerConfiguration} from "../config/map-viewer-configuration";
import {NavigationConfiguration} from "../config/navigation-configuration";
import {Item} from "semantic-ui-react";
import {Auftragsverwaltung} from "../stores/auftragsverwaltung-mobx";
import {Adresse} from "../components/app/aside/adresse";

export interface KontaktProps {
    appStore: AppState;
    auftragsverwaltung: Auftragsverwaltung;
    mapViewerConfig: MapViewerConfiguration;
}

export class Kontakt extends React.Component<KontaktProps, any> {
    constructor(props: KontaktProps) {
        super(props);
    }
    componentDidMount(): void {
        const {appStore, auftragsverwaltung} = this.props;
        const breadcrumbs = new NavigationConfiguration();
        breadcrumbs.items = [
            { title: "Kontakt" }
        ];
        appStore.setBreadcrumbs(breadcrumbs);
        appStore.setPageTitle("Kontakt");
        appStore.setShowAside(true);
        appStore.setAsideContent(null);
        auftragsverwaltung.setShowMap(false);
    }
    render(): React.ReactElement | null {
        const {mapViewerConfig} = this.props;
        return(
            <div><p>Für weitere Informationen zur Notfallplanung Naturgefahren Luzern und zum Informationssystem sowie für allgemeine
                Fragen wenden Sie sich bitte an folgende Stellen:</p>
            <Item.Group>
                <Item>
                    <Adresse adresse={"kontakt_intern"} mapViewerConfig={mapViewerConfig} heading={"h3"} />
                </Item>
                <Item>
                    <Adresse adresse={"kontakt_extern"} mapViewerConfig={mapViewerConfig} heading={"h3"} />
                </Item>
                <Item>
                    <Adresse adresse={"kontakt_technisch"} mapViewerConfig={mapViewerConfig} heading={"h3"} />
                </Item>
            </Item.Group>
            </div>
        );
    }
}
